// The four jurisdiction-product pairs the calculator covers. The
// maintenance interface iterates over this list to drive the Dashboard
// cards, the Matrix view tabs, the Comparison selectors, and the
// History view's per-product timelines.

import type { Jurisdiction, ProductId } from './types';

export interface ProductDescriptor {
  jurisdiction: Jurisdiction;
  product: ProductId;
  label: string;
  customerLabel: string;
  pricingModel: 'bureau_band_x_housing_x_channel' | 'grade_x_subgrade_x_channel';
  cubeShapeLabel: string;
}

export const PRODUCTS: ProductDescriptor[] = [
  {
    jurisdiction: 'au',
    product: 'unsecured-personal-loan',
    label: 'AU Unsecured',
    customerLabel: 'Personal Loan',
    pricingModel: 'bureau_band_x_housing_x_channel',
    cubeShapeLabel: 'bureau × housing'
  },
  {
    jurisdiction: 'au',
    product: 'secured-vehicle-loan',
    label: 'AU Secured',
    customerLabel: 'Vehicle Loan',
    pricingModel: 'bureau_band_x_housing_x_channel',
    cubeShapeLabel: 'bureau × housing'
  },
  {
    jurisdiction: 'nz',
    product: 'unsecured-personal-loan',
    label: 'NZ Unsecured',
    customerLabel: 'Personal Loan',
    pricingModel: 'grade_x_subgrade_x_channel',
    cubeShapeLabel: 'grade × subgrade'
  },
  {
    jurisdiction: 'nz',
    product: 'secured-vehicle-loan',
    label: 'NZ Secured',
    customerLabel: 'Vehicle Loan',
    pricingModel: 'bureau_band_x_housing_x_channel',
    cubeShapeLabel: 'bureau × housing'
  }
];

export function productKey(p: { jurisdiction: Jurisdiction; product: ProductId }): string {
  return `${p.jurisdiction}/${p.product}`;
}

export function findProduct(jurisdiction: Jurisdiction, product: ProductId): ProductDescriptor | undefined {
  return PRODUCTS.find((p) => p.jurisdiction === jurisdiction && p.product === product);
}
